import { Color } from "../../defines/colors"
import { MapID } from "../../defines/enums"
import { Symbol } from "../../defines/symbols"
import { Position } from "../../defines/types"
import { mapIDToString } from "../../utils/map"
import { Entity } from "../entity"

export class MapPortal extends Entity {
  constructor(public target: MapID, position: Position) {
    const render = {
      symbol: [Symbol.PORTAL],
      light: Color.PORTAL_FG,
      dark: Color.PORTAL_DARK_FG,
    }
    super(position, true, render, "Portal to " + mapIDToString(target))
  }
}
